import { Info } from 'lucide-react'
import { useI18n } from '../i18n'

/**
 * NetworkDisclaimer — s105 (TestFlight b71, Dr. Rami: "Add a disclaimer. Office will have final
 * determination on confirming in network status / accepting your insurance as there could rare plans the
 * MD does not accept or variations to plans"; copy approved en + es 2026-10-15). One sentence, one
 * spelling, wherever the app says a doctor is in network or a copay is verified: the share step's
 * coverage chip, the check-in copay card and the doctor profile's in-network line.
 */
export default function NetworkDisclaimer({ className = '' }) {
  const { t } = useI18n()
  return (
    <p data-network-disclaimer className={`text-[11px] leading-snug flex items-start gap-1.5 ${className}`} style={{ color: '#64748B' }}>
      <Info size={12} className="shrink-0 mt-[1px]" style={{ color: '#93A5B4' }} />
      <span>{t('eligibility.officeFinalSay')}</span>
    </p>
  )
}
